module.exports = __webpack_public_path__ + "assets/media/7.83ecc4c3.wav";